<div class="input-container">
	<label class="input-label" for="workspace-filter" translate="search.filter.workspace.title"></label>
	@if (workspaceFilterOptions$ | async; as workspaceFilterOptions) {
		<select
			id="workspace-filter"
			class="select fullsize"
			[(ngModel)]="selectedWorkspaceFilterOption"
			(change)="onFilterChange()"
		>
			@for (workspaceFilterOption of workspaceFilterOptions; track workspaceFilterOption) {
				<option [ngValue]="workspaceFilterOption" [translate]="workspaceFilterOption.name">></option>
			}
		</select>
	}
	<div class="info"></div>
</div>

@if (typeFilterOptions && objectKeys(typeFilterOptions).length > 0) {
	<div class="input-container">
		<h5 class="input-label" translate="search.filter.type.title"></h5>
		<ul class="checkbox-group">
			@for (displayTypeName of objectKeys(typeFilterOptions); track displayTypeName) {
				<li>
					<input
						type="checkbox"
						id="{{ displayTypeName }}"
						class="checkbox"
						[(ngModel)]="typeFilterOptions[displayTypeName]"
						(change)="onFilterChange()"
					/>
					<label for="{{ displayTypeName }}"
						><span class="p2">{{ displayTypeName }}</span></label
					>
				</li>
			}
		</ul>
		<div class="info"></div>
	</div>
}

@if (pvFilterVisible) {
	<div class="input-container">
		<label for="versions" class="input-label" translate="search.filter.process.version.title"></label>
		<select id="versions" class="select fullsize" [(ngModel)]="selectedPVFilterOption" (change)="onFilterChange()">
			@for (pvFilterOption of pvFilterOptions; track pvFilterOption) {
				<option [ngValue]="pvFilterOption">
					{{ pvFilterOption | processVersionMarkValidVersion: validVersionName }}
				</option>
			}
		</select>
		<div class="info"></div>
	</div>
}
